import {parseHtml} from "../../commons/commons";
import {Dict} from "wfr/commons/common"
import {ENavLanguages, EProductType, JDlInfos, JProductGroup, JProductPanel, L10nLabels} from "../../commons/api";
import {JSX} from "wfr/commons/jsx"
import {alertFromLocInfos} from "../../commons/popup";
import {msgList, DownloadProductComponent, productInfos} from "./product";
import {DownloadLink} from "./download-link";
import {lang} from "../../commons/language-selector";
import {DownloadMessageBox} from "./product-message-box";
import {qs, updateHistory} from "wfr/commons/core";

export {ProductsBox}

const	labels:L10nLabels = {
	[ENavLanguages.fr]: {
		learnMore: "En savoir plus",
	},
	[ENavLanguages.en]: {
		learnMore: "Learn more",
	}
}

/**
 * Code de class d'icone associé à un env.
 * Cette map est utilisée pour mettre premier (ouverture forcée) les groupes de l'env préférentiel pour les produits de type app.
 */
const grpClassToEnv:Dict<string> = {
	win:"windows",
	mac:"mac",
	lin:"linux",
	appimage:"linux",
	ubuntu:"linux",
	deb:"linux"
}


class ProductsBox extends DownloadProductComponent {
	labels = labels
	protected groupsByCode:Dict<JProductGroup> = {}
	protected childrenByGroupCode:Dict<JDlInfos[]> = {}
	protected grpOthers:JProductGroup

	loadData() {
		super.loadData();
		//Chargement des children dans les groupes
		productInfos.ch.forEach(child=>{
			let foundGrp = false;
			const grpcb = (group: JProductGroup) =>{
				const code = group.code
				if(!(code in this.groupsByCode)) this.groupsByCode[code] = group
				if(!(code in this.childrenByGroupCode)) this.childrenByGroupCode[code] = []

				if(group.grpOthers) this.grpOthers = group;
				else {
					if (child.prc == "dlProduct" && group.regexps) group.regexps.forEach(regexp => {
						if (child.n.match(regexp)) {
							this.childrenByGroupCode[group.code].push(child);
							foundGrp = true;
						}
					});
					if (group.olProducts) group.olProducts.forEach(pOlProduct => {
						if (child.metas.path == pOlProduct) {
							this.childrenByGroupCode[group.code].push(child)
							foundGrp = true;
						}
					});
				}
			}
			productInfos.metas.structure.panels?.forEach(panel => {panel.groups.forEach(grpcb)});
			productInfos.metas.structure.groups.forEach(grpcb);
			if(!foundGrp) this.childrenByGroupCode[this.grpOthers.code].push(child);
		})
	}

	rebuild() {
		if(!super.rebuild()) return false;
		this.shadowRoot.append(<div class="panelsButtons">
			{productInfos.metas.structure.panels?.map((panel, i) => {
				const selected = qs().panel == panel.code || !qs().panel && i == 0
				const title = panel.locInfos[lang].title
				const showAlert = ()=>{ alertFromLocInfos(panel.locInfos)}
				return <div class="panelButton">
					<button id={`button_${panel.code}`} class={"panelButton "+(selected?"selected":"")} title={title} onclick={this.changePanel} data-panel={panel.code}><span>{title}</span></button>
					{panel.locInfos[lang].body ? <button class="panelPopup" title={this.s("learnMore")} onclick={showAlert}><span>{this.s("learnMore")}</span></button>:null}
				</div>
			})}
		</div>)

		if(productInfos.metas.structure.panels) this.shadowRoot.append(<div class="panels">
			{productInfos.metas.structure.panels?.map((panel, i) => { return this.buildPanel(panel, qs().panel == panel.code || !qs().panel && i == 0)})}
		</div>)

		//Common groups
		this.shadowRoot.append(<div class="groups">
			{productInfos.metas.structure.groups.map(group=>{return this.buildGrp(group, "all", "all", false, null)})}
			{/*this.grpOthersChildren.length > 0 ? this.buildGrp(this.grpOthers, "all", "all", false, null) : null*/}
		</div>)

		return true;
	}
	/**
	 * Construction d'un panel
	 */
	protected buildPanel(panel:JProductPanel, selected:boolean){
		const foundLanguages:Dict<boolean> = {}
		const foundOs:Dict<boolean> = {}
		panel.groups.forEach(group=>{
			this.childrenByGroupCode[group.code].forEach(child=>{
				if(child.metas.os != "all") foundOs[child.metas.os] = true
				if(child.metas.lang && child.metas.lang != "all") foundLanguages[child.metas.lang.split("-").shift()] = true
			})
		})

		const languages = Object.keys(foundLanguages)
		const envs = Object.keys(foundOs)

		let selectedLanguage =  sessionStorage.getItem("download.selected-language") in foundLanguages ? sessionStorage.getItem("download.selected-language") : "all"
		let selectedOs = sessionStorage.getItem("download.selected-os") in foundOs ? sessionStorage.getItem("download.selected-os") : "all"
		if(selected){
			selectedLanguage = qs().lang || selectedLanguage
			selectedOs = qs().os || selectedOs
		}

		const prefLanguages = selectedLanguage == "all" ? this.getPrefLang(languages) : null
		const prefOs = selectedOs == "all" ? this.getPrefOs(envs) : null

		return <div class="panel" id={panel.code} hidden={!selected}>
			{languages.length > 1 || envs.length > 1? <div class="selectorBars">
				<div class="selectors">
					{languages.length > 1 ?
						<select class="downloadLanguagesSelector" onchange={this.selectChange}>
							<option value="all" selected={selectedLanguage=="all"}>{this.s("l10n")}</option>
							{languages.map(lang=> {return <option value={lang} selected={selectedLanguage==lang}>{this.s(`l10n_${lang}`)}</option>})}
						</select>:""}
					{envs.length > 1 ?
						<select class="downloadEnvSelector" onchange={this.selectChange}>
							<option value="all" selected={selectedLanguage=="all"}>{this.s("env")}</option>
							{envs.map(env=> {return <option value={env} selected={selectedOs==env}>{this.s(`env_${env}`)}</option>})}
						</select>:""}
				</div>
				<div class="buttons">
					<button class="reset" title={this.s("reset")} disabled={selectedLanguage == "all" && selectedOs == "all"} onclick={this.resetButton}>
						<span>{this.s("reset")}</span>
					</button>
				</div>
			</div>:null}

			{productInfos.metas.productType == EProductType.application && prefOs ?
				//Step 1. Affichage en mode ouvert des groupes associés à l'OS
				panel.groups.map(group=> {
					if(grpClassToEnv[group.iconClass] == prefOs) return this.buildGrp(group, selectedLanguage, selectedOs, false, prefLanguages)
				}):null}
			{productInfos.metas.productType == EProductType.application && prefOs ?
				//Step 2. Affichage en mode fermé par défaut des groupes non associés à l'OS
				panel.groups.map(group=> {
					if(grpClassToEnv[group.iconClass] != prefOs) return this.buildGrp(group, selectedLanguage, selectedOs, true, prefLanguages)
				}):null}
			{productInfos.metas.productType != EProductType.application || prefOs == null ?
				//Step 3. Affichage normal des groupes
				panel.groups.map(group=> {
					return this.buildGrp(group, selectedLanguage, selectedOs, false, prefLanguages)
				}):null}
		</div>
	}

	/**
	 * Construction graphique d'un groupe
	 */
	protected buildGrp(group:JProductGroup, selLang:string, selOs:string, forceClosed:boolean, prefLang:string):Element {
		const hiddenChild = (dlInfos:JDlInfos, selLang:string, selOs:string)=> {
			return dlInfos.metas.lang?.split("-")[0] != selLang && selLang != "all" || dlInfos.metas.os != selOs && selOs != "all"
		}

		const hiddenGrp = this.childrenByGroupCode[group.code].every(dlInfos=> {return hiddenChild(dlInfos, selLang, selOs)})
		const collapsed = forceClosed || group.collapsed

		return <div class={`group ${group.iconClass} ${collapsed ? "closed" : "opened"}`} id={group.code} hidden={hiddenGrp}>
			<div class="grpHead">
				<div class="grpTitle"><span class="grpTitle">{group.locInfos[lang].title}</span></div>
				<div class="grpButtons">
					<button class={collapsed?"openGrp":"closeGrp"} title={this.s(collapsed?"open":"close")} onclick={this.toggleGrp}><span>{this.s(collapsed?"open":"close")}</span></button>
				</div>
			</div>
			<div class="grpContent" hidden={collapsed}>
				<div class="messages">
					{msgList.map(msg=>{
						if(msg.grpCodes?.includes(group.code)){
							return new DownloadMessageBox(msg);
						}
					})}
				</div>
				{group.locInfos[lang].body ? <div class="grpInfo">{parseHtml(group.locInfos[lang].body)}</div> : null}
				<ul class="productList">
					{prefLang ? this.childrenByGroupCode[group.code].map(dlInfos => {
						//Step 1. On affiche en premier la langue de préférence s'il y a lieu
						if (dlInfos.metas.lang?.substring(0,2) == prefLang) return this.buildChild(dlInfos, hiddenChild(dlInfos, selLang, selOs), true)
					}) : null}
					{this.childrenByGroupCode[group.code].map(dlInfos => {
						//Step 2. On affiche les autres langues (ou toutes les langues s'il n'y a pas de langue de préférence)
						if (prefLang && dlInfos.metas.lang?.substring(0,2) != prefLang) return this.buildChild(dlInfos, hiddenChild(dlInfos, selLang, selOs), false)
						else if (!prefLang) return this.buildChild(dlInfos, hiddenChild(dlInfos, selLang, selOs), false)
					})}
				</ul>
			</div>
		</div>
	}

	/**
	 * Construction d'un lien de téléchargement
	 */
	protected buildChild(dlInfos: JDlInfos, hidden: boolean, prefLang: boolean) {
		return <li class={`${dlInfos.prc} ${prefLang ? "prefLanguage" : ""}`} hidden={hidden} data-os={dlInfos.metas.os} data-lang={dlInfos.metas.lang}>
			{new DownloadLink(dlInfos)}
		</li>
	}

	/*****************************************
	 * 					Listerners
	 ******************************************/

	protected changePanel(event:Event){
		const panelId = this.getAttribute("data-panel");
		(this.getRootNode() as ShadowRoot).querySelectorAll("div.panel").forEach(panel=>{
			if(panel.id == panelId) panel.removeAttribute("hidden")
			else panel.setAttribute("hidden", "true")
		});
		(this.getRootNode() as ShadowRoot).querySelectorAll("div.panelsButtons button.panelButton").forEach(button=>{
			if(this == button) button.classList.add("selected")
			else button.classList.remove("selected")
		})
		updateHistory({"panel":panelId}, {replaceHist:true})
	}

	protected toggleGrp(event:Event){
		const pb = (this.getRootNode() as ShadowRoot).host as ProductsBox
		const button = (event.target as Element).closest("button");
		if(button.classList.contains("openGrp")){
			button.classList.remove("openGrp")
			button.classList.add("closeGrp")
			button.setAttribute("title", pb.s("close"))
			button.innerHTML = `<span>${pb.s("close")}</span>`
			button.closest("div.grpHead").nextElementSibling.removeAttribute("hidden");
		}
		else{
			button.classList.remove("closeGrp")
			button.classList.add("openGrp")
			button.setAttribute("title", pb.s("open"))
			button.innerHTML = `<span>${pb.s("open")}</span>`
			button.closest("div.grpHead").nextElementSibling.setAttribute("hidden", "true");
		}
	}

	protected selectChange(event:Event) {
		let selLang:string = "all";
		let selOs:string = "all";
		const pb = ((event.target as HTMLElement).getRootNode() as ShadowRoot).host as ProductsBox
		const panel = pb.shadowRoot.querySelector("div.panel:not([hidden])");
		panel.querySelectorAll("select").forEach(select=>{
			if(select.classList.contains("downloadLanguagesSelector")) selLang = select.value
			else if(select.classList.contains("downloadEnvSelector")) selOs = select.value
		});

		panel.querySelectorAll("div.group").forEach(divGrp=>{
			const grp = pb.groupsByCode[divGrp.id]
			if(selOs && selOs != "all" && grpClassToEnv[grp.iconClass] != selOs) divGrp.setAttribute("hidden", "true")
			else divGrp.removeAttribute("hidden");
			divGrp.querySelectorAll("li").forEach(li=>{
				const liLang = li.getAttribute("data-lang")
				const liOs = li.getAttribute("data-os")
				if(selLang && selLang != "all" && liLang != "all" && !liLang.match(`^${selLang}.*$`)) li.setAttribute("hidden", "true");
				else if(selOs && selOs != "all" && liOs != "all" && liOs != selOs) li.setAttribute("hidden", "true")
				else li.removeAttribute("hidden")
			})
			if(!divGrp.hasAttribute("hidden") && !divGrp.querySelector("li:not([hidden])")) divGrp.setAttribute("hidden", "true");
			if(grp.collapsed) (divGrp.querySelector("button.closeGrp") as HTMLButtonElement)?.click()
			else (divGrp.querySelector("button.openGrp") as HTMLButtonElement)?.click()
			const reset = panel.querySelector("button.reset");
			if(selLang == "all" && selOs == "all") reset.setAttribute("disabled", "true");
			else reset.removeAttribute("disabled");
		})
		updateHistory({"lang":selLang, "os":selOs}, {mergeQS:true, replaceHist:true})
	}

	protected resetButton(event: Event) {
		const pb = (this.getRootNode() as ShadowRoot).host as ProductsBox
		(event.target as HTMLElement).closest("div.buttons").previousElementSibling.querySelectorAll("select").forEach(select=>{select.value = "all";});
		pb.selectChange(event);
	}

	/*****************************************
	 * 					UTILS
	 ******************************************/
	/**
	 * retourne la langue de préférence du navigateur si elle est présente parmis la liste passée en param.
	 * On ne match que les 2 premiers caractères de la langue.
	 */
	protected getPrefLang(languages: string[]) {
		const langIndex = languages.map(lang => lang.substring(0, 2)).indexOf(navigator.language.substring(0, 2))
		return langIndex !== -1 ? languages[langIndex] : null
	}


	/**
	 * Retourne l'OS du navigateur normalisé si trouvé dans le userAgent
	 */
	protected getPrefOs(envs: string[]) {
		const ua = navigator.userAgent;
		if (ua.indexOf("Mac") !== -1 && envs.includes("mac")) return "mac";
		if (ua.indexOf("Linux") !== -1 && envs.includes("linux")) return "linux";
		if (ua.indexOf("Windows") !== -1 && envs.includes("windows")) return "windows";
		return null
	}
}
customElements.define('products-box', ProductsBox)